import { call, put, takeLatest } from "typed-redux-saga";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { createCustomNotificationAction } from "../../../app/actions";
import { RESOURCE_KEYS } from "../../../localization";
import { deleteDocument } from "../../../utilities/rpcHelper";
import { executeBusy } from "../../../utilities/workflowUtils";

import { deleteProcessDocument } from "../actions";

const DELETE_RESSOURCE_KEYS = RESOURCE_KEYS.features.deleteProcess;
export function* deleteProcessDocumentSaga() {
	yield* takeLatest(deleteProcessDocument, function* (action) {
		yield* call(executeBusy, function* deleteProcessDocuments() {
			yield* call(deleteDocuments, action.payload.instanceId, action.payload.overviewActivityId);
			yield* put(ActivityActions.cancel({ activityId: action.payload.modalActivityId }));
			yield* put(ActivityActions.reloadData({ activityId: action.payload.overviewActivityId }));
		});
	});
}

function* deleteDocuments(docRef: string, overviewActivityId: string) {
	try {
		yield* call(deleteDocument, docRef);
	} catch (error) {
		yield* put(
			createCustomNotificationAction({
				activityId: overviewActivityId,
				severity: "error",
				message: { key: DELETE_RESSOURCE_KEYS.error },
				group: `deleteDocument:${docRef}`
			})
		);
	}
}
